import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import i18n from 'i18next';
import { getAwsApiBaseUrl } from '../../utils/awsApiBaseUrl';
import { userActions } from '../../actions';
import { storeLUCCredentials } from '../../services/user.service';
import { removeLocalStorageItem } from '../../utils/cookieAndLocalStorageUtils';
import { notify } from '../CommonNotification/CommonNotification';
import { history } from '../../history';
import { userConstants } from '../../constants';

const LOGIN_REQUEST_TIMEOUT_MS = 30000;
const cookies = new Cookies();

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  );
}

class AuthCallbackComponent extends Component {
  componentDidMount() {
    this.authenticateWithCookies();
  }

  async authenticateWithCookies() {
    const { dispatch } = this.props;
    const loginUrl = `${getAwsApiBaseUrl()}/awsluc/login`;

    // Generate user_session BEFORE the API call so it's available as x-user-uuid
    const d = new Date();
    d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
    cookies.set('user_session', guid(), {
      path: '/',
      expires: d,
      secure: true,
    });

    try {
      const response = await axios.post(loginUrl, null, {
        headers: {
          Authorization: 'cookie regeneratetoken',
          'x-user-uuid': cookies.get('user_session'),
        },
        withCredentials: true,
        timeout: LOGIN_REQUEST_TIMEOUT_MS,
      });

      const credentials = response.data?.data?.credentials;
      if (!credentials?.access_token) {
        throw new Error('No access_token in login response');
      }

      if (credentials.user?.username) {
        cookies.set('username', credentials.user.username.toLowerCase(), {
          path: '/',
          expires: d,
          secure: true,
        });
      }

      // Mirror storeData: persist access_token + fetch inventory cookies
      await storeLUCCredentials(credentials.access_token);

      // Mirror userActions.login: dispatch LOGIN_SUCCESS + set admin_message_visible
      dispatch({ type: userConstants.LOGIN_SUCCESS });
      cookies.set('admin_message_visible', true, {
        path: '/',
        secure: true,
      });

      // Mirror userActions.login: fetch & dispatch user info, then validate type
      const userInfo = await dispatch(userActions.getUserInfo());
      if (userInfo?.type && userInfo.type !== 'luc_application') {
        notify('error', i18n.t('CONTACTSUPPORT'));
        removeLocalStorageItem('access_token');
        dispatch({ type: userConstants.LOGIN_FAILURE });
        history.push('/login');
        return;
      }

      history.push('/dashboard/units');
    } catch (error) {
      console.error('[AuthCallback] Login failed:', error?.message || error);
      history.push('/login');
    }
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '1.2rem',
        }}
      >
        Processing login...
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({ dispatch });

export const AuthCallback = connect(null, mapDispatchToProps)(AuthCallbackComponent);
